import React from 'react';

import { api } from '~/api';
import Modal from '~/components/modals/modal';
import ForgotPasswordForm from '~/components/sessions/forgot-password/forgot-password-form';
import { pestQuestionnaireRoute } from '~/routes';
import { useFlashMessage } from '~/features/flash-messages/flash-message-actions';

import modalStyles from '~/components/modals/modal.module.scss';

const ForgotPasswordModal = ({ onClose, isOpen, lawnUuid }) => {
  const { showFlashMessage } = useFlashMessage();
  const handleSubmit = async (formValues) => {
    const { email } = formValues;

    await api.sessions.forgotPassword({
      email,
      queryParams: {
        redirect: pestQuestionnaireRoute(lawnUuid),
      },
    });
    showFlashMessage(
      <span>
        We'll send you an email at <strong>{email}</strong>, look for it in the
        next couple of minutes.
      </span>,
      'success'
    );
    onClose();
  };
  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      className={modalStyles.forgotPasswordModal}
    >
      <h1>Forgot your password?</h1>
      <p>
        Enter your email address below and we'll send you a link you can use to
        sign in.
      </p>
      <ForgotPasswordForm onSubmit={handleSubmit} />
    </Modal>
  );
};

export default ForgotPasswordModal;
